import React from 'react';
import PropTypes from 'prop-types';
import { Provider as ReduxProvider } from 'react-redux';
import { createStore } from 'redux/create';
import { ParamsContext } from 'components/Context/ParamsContext';
import { extractParams, getParamsPropShape } from 'config/params';

const RootProvider = ({ initialState, children, ...props }) => (
  <ReduxProvider store={createStore(initialState)}>
    <ParamsContext.Provider value={extractParams(props)}>
      {children}
    </ParamsContext.Provider>
  </ReduxProvider>
);

RootProvider.propTypes = {
  initialState: PropTypes.object,
  children: PropTypes.any,
  ...getParamsPropShape()
};

export default RootProvider;
